module.exports = "/images/menu.png?22dd2c86e54f5f6f4ca0b25952f809a6";